import React, { useContext } from "react";

import { DialogContext } from "contexts/dialogContext";
import { SetDialogContext } from "contexts/setDialogContext";

import * as dialogs from "./constants";

import ConfirmDialog from "./ConfirmDialog";
import AddAccountDialog from "./accounts/AddAccountDialog";
import EditAccountDialog from "./accounts/EditAccountDialog";
import AddFeatureGroupDialog from "./featureGroups/AddFeatureGroupDialog";
import AddFeatureTypeDialog from "./featureGroups/AddFeatureTypeDialog";
import CreateLicenseTemplateDialog from "./licenses/CreateLicenseTemplateDialog";
import UpdateLicenseTemplateDialog from "./licenses/UpdateLicenseTemplateDialog";
import CreateLicenseLimitDialog from "./licenses/CreateLicenseLimitDialog";
import UpdateLicenseLimitDialog from "./licenses/UpdateLicenseLimitDialog";
import UpdateLicenseTemplateLimitDialog from "./licenses/UpdateLicenseTemplateLimitDialog";
import AddVersionDialog from "./versions/AddVersionDialog";
import AddPushCenterDialog from "./pushCenters/AddPushCenter";
import AddIncrementalUpgradeVersion from "./incrementalUpgrade/AddIncrementalUpgradeVersion";
import AddRoleDialog from "dialogs/system/AddRoleDialog";
import AddUserDialog from "./system/AddUserDialog";
import EditUserDialog from "./system/EditUserDialog";
import UpdateLicenseCertificate from "./system/UpdateLicenseCertificate";
import AddLocaleDialog from "./versions/AddLocaleDialog";
import AssignVersionFileDialog from "./versions/AssignVersionFileDialog";
import UpdateOtaHmacDialog from "./packages/UpdateOtaHmacDialog";
import DeleteOtaHmacDialog from "./packages/DeleteOtaHmacDialog";
import AboutDialog from "dialogs/AboutDialog";
import UpdateBillingUrlDialog from "dialogs/services/AddBillingUrlDialog";
import UpdatePatchTagsDialog from "./IQPatchTags/UpdatePatchTagsDialog";
import DeletePatchTagsDialog from "./IQPatchTags/DeletePatchTagsDialog";
import CreateAccountNote from "./account/CreateAccountNote";
import UpdateAccountNote from "./account/UpdateAccountNote";
import UpdateAccountDealerInfo from "./account/UpdateDealerInfo";
import UpdateOktaSettingsDialog from "dialogs/system/UpdateOktaSettingsDialog";
import CreateAccountAppTheme from "./account/CreateAccountAppTheme";
import UpdateAccountAppTheme from "./account/UpdateAccountAppTheme";
import UpdateSmtpSettingsDialog from "./system/UpdateSmtpSettingsDialog";
import UpdateActionLogSettingsDialog from "./system/UpdateActionLogSettingsDialog";
import UpdateFtpSettingsDialog from "./system/UpdateFtpSettingsDialog";

const components = {
  [dialogs.DIALOG_CONFIRM]: ConfirmDialog,
  [dialogs.DIALOG_ADD_ACCOUNT]: AddAccountDialog,
  [dialogs.DIALOG_EDIT_ACCOUNT]: EditAccountDialog,
  [dialogs.DIALOG_ADD_FEATURE_GROUP]: AddFeatureGroupDialog,
  [dialogs.DIALOG_ADD_FEATURE_TYPE]: AddFeatureTypeDialog,
  [dialogs.DIALOG_CREATE_LICENSE_TEMPLATE]: CreateLicenseTemplateDialog,
  [dialogs.DIALOG_UPDATE_LICENSE_TEMPLATE]: UpdateLicenseTemplateDialog,
  [dialogs.DIALOG_CREATE_LICENSE_LIMIT]: CreateLicenseLimitDialog,
  [dialogs.DIALOG_UPDATE_LICENSE_LIMIT]: UpdateLicenseLimitDialog,
  [dialogs.DIALOG_UPDATE_LICENSE_TEMPLATE_LIMIT]:
    UpdateLicenseTemplateLimitDialog,
  [dialogs.DIALOG_ADD_VERSION]: AddVersionDialog,
  [dialogs.DIALOG_ADD_VERSION_LOCALE]: AddLocaleDialog,
  [dialogs.DIALOG_ADD_IU_VERSION]: AddIncrementalUpgradeVersion,
  [dialogs.DIALOG_CREATE_PUSH_CENTER]: AddPushCenterDialog,
  [dialogs.DIALOG_ADD_ROLE]: AddRoleDialog,
  [dialogs.DIALOG_ADD_USER]: AddUserDialog,
  [dialogs.DIALOG_EDIT_USER]: EditUserDialog,
  [dialogs.DIALOG_UPDATE_HMAC]: UpdateOtaHmacDialog,
  [dialogs.DIALOG_DELETE_HMAC]: DeleteOtaHmacDialog,
  [dialogs.DIALOG_ASSIGN_FILES_TO_VERSION]: AssignVersionFileDialog,
  [dialogs.DIALOG_ABOUT]: AboutDialog,
  [dialogs.DIALOG_UPDATE_BILLING_URL]: UpdateBillingUrlDialog,
  [dialogs.DIALOG_UPDATE_OKTA_SETTINGS]: UpdateOktaSettingsDialog,
  [dialogs.DIALOG_UPDATE_SMTP_SETTINGS]: UpdateSmtpSettingsDialog,
  [dialogs.DIALOG_UPDATE_ACTION_LOG_SETTINGS]: UpdateActionLogSettingsDialog,
  [dialogs.DIALOG_UPDATE_FTP_SETTINGS]: UpdateFtpSettingsDialog,
  [dialogs.DIALOG_UPDATE_PATCH_TAG]: UpdatePatchTagsDialog,
  [dialogs.DIALOG_DELETE_PATCH_TAG]: DeletePatchTagsDialog,
  [dialogs.DIALOG_UPDATE_LICENSE_CERTIFICATE]: UpdateLicenseCertificate,
  [dialogs.CREATE_ACCOUNT_NOTE]: CreateAccountNote,
  [dialogs.UPDATE_ACCOUNT_NOTE]: UpdateAccountNote,
  [dialogs.UPDATE_ACCOUNT_DEALER_INFO]: UpdateAccountDealerInfo,
  [dialogs.CREATE_ACCOUNT_APP_THEME]: CreateAccountAppTheme,
  [dialogs.UPDATE_ACCOUNT_APP_THEME]: UpdateAccountAppTheme,
};

const DialogsContainer = () => {
  const { name, args } = useContext(DialogContext);
  const setDialog = useContext(SetDialogContext);

  const onClose = () => setDialog({ name: "", args: {} });

  if (!name) {
    return null;
  }

  if (!components[name]) {
    throw new Error(`Unknown modal type ${name}`);
  }

  const Component = components[name];

  return <Component ariaLabelledby={name} {...args} onClose={onClose} />;
};

DialogsContainer.propTypes = {};

export default DialogsContainer;
